var x = Object.defineProperty;
var S = (o, e, t) => e in o ? x(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var l = (o, e, t) => S(o, typeof e != "symbol" ? e + "" : e, t);
import { E as y } from "./index-es2.js";
import { a as _ } from "./index-es.js";
import d from "../DomHelper.js";
import C from "../Selection.js";
import b from "../SelectionHelper.js";
let f = "/apiproxy";
const p = "/v1/notebook/highlight";
function L(o, e) {
  const t = `${f}${p}`, i = new FormData();
  Object.entries(o).forEach(([n, c]) => {
    n === "references" && typeof c != "string" ? i.append(n, JSON.stringify(c)) : i.append(n, c);
  });
  const s = {
    "Content-Type": "application/x-www-form-urlencoded",
    "X-Token": e
  };
  return _.post(
    t,
    i,
    {
      headers: s,
      withCredentials: !0
    }
  );
}
function $(o) {
  const e = `${f}${p}/${o}`;
  return _.delete(
    e,
    {
      withCredentials: !0
    }
  );
}
function j() {
  return f;
}
function F(o) {
  const e = `${f}${p}`;
  return _.get(
    e,
    {
      params: {
        concept_id: o
      }
    }
  );
}
function M(o) {
  const e = `${f}${p}/reference`;
  return _.get(
    e,
    {
      params: {
        references: JSON.stringify(o)
      }
    }
  );
}
function k(o = null) {
  var e;
  f = ((e = o == null ? void 0 : o.trim()) == null ? void 0 : e.replace(/[/]+$/, "")) || "";
}
function w(o, e) {
  const t = `${f}${p}/${o}`;
  return _.patch(
    t,
    e,
    {
      withCredentials: !0
    }
  );
}
const a = "de-highlight", h = {
  BLUE: "blue",
  GREEN: "green",
  PINK: "pink",
  YELLOW: "yellow"
};
Object.freeze(h);
const E = /* @__PURE__ */ new Map();
E.set(
  h.BLUE,
  {
    color: h.BLUE,
    css: [
      a,
      `${a}--blue`
    ],
    legacyCss: [
      "highlighted",
      "hl_blue"
    ]
  }
);
E.set(
  h.GREEN,
  {
    color: h.GREEN,
    css: [
      a,
      `${a}--green`
    ],
    legacyCss: [
      "highlighted",
      "hl_green"
    ]
  }
);
E.set(
  h.PINK,
  {
    color: h.PINK,
    css: [
      a,
      `${a}--pink`
    ],
    legacyCss: [
      "highlighted",
      "hl_pink"
    ]
  }
);
E.set(
  h.YELLOW,
  {
    color: h.YELLOW,
    css: [
      a,
      `${a}--yellow`
    ],
    legacyCss: [
      "highlighted",
      "hl_yellow"
    ]
  }
);
var I;
const r = class r {
  /**
   * @param {Object} options The options to be used by the Selection instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   */
  constructor(e) {
    // Only used for rendering on the client
    l(this, "_clientId", null);
    l(this, "color", null);
    l(this, "_domHelper", null);
    l(this, "_eventBus", null);
    // ID of highlight in the database (upon save)
    l(this, "id", null);
    l(this, "metadata", null);
    l(this, "_note", null);
    l(this, "_selection", null);
    l(this, "_selectionText", null);
    this._clientId = r.getNextClientId(), this._eventBus = new y(), this.metadata = {}, this._domHelper = new d({
      contextContainer: e == null ? void 0 : e.contextContainer,
      ignoredElements: e == null ? void 0 : e.ignoredElements,
      nodeSelectors: e == null ? void 0 : e.nodeSelectors
    }), this.setColor(
      r.color.YELLOW
    ), r.add(this);
  }
  /**
   * The unique client ID of this instance.
   * @type {Number}
   * @readonly
   *
   * @example
   * const highlight = new Highlight();
   *
   * // prints the client-id
   * console.log(highlight.clientId);
   *
   * // throws an exception
   * highlight.clientId = 123;
   */
  get clientId() {
    return this._clientId;
  }
  get colorCss() {
    return r.colorMeta.get(this.color) || null;
  }
  /**
   * The context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   */
  get contextContainer() {
    return this.domHelper.contextContainer;
  }
  set contextContainer(e) {
    this.domHelper.contextContainer = e;
  }
  /**
   * The immediate parent of context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   * @readonly
   */
  get contextContainerParent() {
    var e;
    return ((e = this.contextContainer) == null ? void 0 : e.parentNode) || null;
  }
  get domHelper() {
    return this._domHelper;
  }
  /**
   * The event bus for this instance.
   * @type {EventBus}
   * @readonly
   */
  get eventBus() {
    return this._eventBus;
  }
  /**
   * The array of ignored element selectors.
   * @type {String[]}
   */
  get ignoredElements() {
    return this.domHelper.ignoredElements;
  }
  set ignoredElements(e) {
    this.domHelper.ignoredElements = e;
  }
  /**
   * The node selectors data object.
   * @type {NodeSelectorsData}
   */
  get nodeSelectors() {
    const { nodeSelectors: e } = this.domHelper;
    return {
      ...e,
      selectorPostProcessor: this._selectorPostProcessor
    };
  }
  set nodeSelectors(e) {
    this.domHelper.nodeSelectors = e;
  }
  get note() {
    return this._note;
  }
  set note(e) {
    this._note !== e && (this._note = e, this._note && (this._note.highlight = this));
  }
  /**
   * The {@link Selection} instance linked to this highlight.
   * @type {Selection}
   * @readonly
   */
  get selection() {
    return this._selection;
  }
  /**
   * The text of the highlight.
   * @type {?String}
   * @readonly
   */
  get text() {
    return this._selectionText;
  }
  /**
   * Updates the data for the highlight from the given save-state data and injects it into the DOM.
   * @param {Object} highlightData The highlight save-state data.
   * @returns {Boolean} Returns `true` if successful, `false` otherwise.
   */
  createFromData(e) {
    this.id = e.id || null;
    const t = new C({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });
    if (!t.updateFromData({
      startNodeSelector: e.node1,
      startOffset: e.offset1,
      endNodeSelector: e.node2,
      endOffset: e.offset2
    }))
      return !1;
    t.setStale(), this._selection = t, this._selectionText = e.selectedText || t.text || null;
    const s = (c) => {
      var g, u;
      return (u = (g = e.references) == null ? void 0 : g.find((m) => m.reference_type === c)) == null ? void 0 : u.reference_id;
    };
    this.metadata = {
      asset_id: e.assetId || s("asset"),
      concept_id: e.guidConceptId || s("concept"),
      course_id: e.courseGuid || s("course"),
      page_id: e.page_id || s("page"),
      relationship_type_id: e.relationshipTypeGuid || s("relationship_type"),
      subdiscipline_id: e.subdisciplineGuid || s("subdiscipline"),
      unit_id: e.unitGuid || s("unit"),
      target_asset_id: s("target_asset")
    }, e.note && (this.note = e.note);
    const n = e.color.replace(/^hl_/, "");
    return this.setColor(n), this.createHighlight(), !0;
  }
  /**
   * Updates the data for the highlight from the selection in the
   * provided `SelectionHelper` instance, sets the appropriate `color`,
   * and injects the highlight into the DOM.
   * @param {Object} highlightData The highlight save-state data.
   * @returns {Boolean} Returns a `true` if successful, `false` otherwise.
   */
  createFromSelection(e, t) {
    return this.updateSelection(e), this._selection ? (this.setColor(t), this.createHighlight(), !0) : !1;
  }
  /**
   * Creates and injects the highlights in the DOM.
   */
  createHighlight() {
    const {
      startNode: e,
      startNodeContextElement: t,
      startOffset: i,
      endNode: s,
      endNodeContextElement: n,
      endOffset: c
    } = this._selection;
    if (!e || !s)
      return;
    const g = d.getTextNodeFromOffset(
      t,
      i,
      !0
    ).relativeOffset, u = d.getTextNodeFromOffset(
      n,
      c,
      !1
    ).relativeOffset;
    if (b.clearSelection(), this.removeHighlight(), e === s) {
      this._injectHighlightElement(
        e,
        g,
        u
      ), this.note && this.injectNoteElement(this.note);
      return;
    }
    const m = this.domHelper.getIntermediateTextNodes(
      e,
      s
    );
    m.length && m.forEach((H) => {
      this._injectHighlightElement(
        H
      );
    }), this._injectHighlightElement(
      e,
      g,
      null
    ), this._injectHighlightElement(
      s,
      0,
      u
    ), this.note && this.injectNoteElement(this.note);
  }
  // TODO: How to enforce NOT reusing deleted/stale instances?
  /**
   * Deletes a highlight from the database, and removes it from the DOM and state-management in memory.
   * @returns {Boolean} Returns `true` if a highlight was found and deleted, `false` otherwise.
   */
  async delete() {
    return this.deselect(), this.removeHighlight(), r.remove(this.clientId), this.id ? $(this.id) : !1;
  }
  /**
   * DeSelects/makes inactive a currently active highlight on the screen.
   * @emits Highlight#deselect
   */
  deselect() {
    r.activeHighlight === this && r._setActiveHighlight(null), this.getHighlightElements().forEach((e) => e.classList.remove("de-highlight--selected")), this._dispatchEvent("deselect");
  }
  // TODO: How to enforce NOT reusing destroyed/stale instances?
  /**
   * Helper to clean up highlights from the DOM and memory. This method
   * does NOT delete the highlight from the database. If that is your
   * intention, use `.delete()` instead.
   */
  destroy() {
    this.deselect(), this.removeHighlight(), r.remove(this.clientId);
  }
  /**
   * Dispatch an event on the event-bus.
   * @private
   * @param {String} eventName The name of the event to dispatch.
   * @param {Object} [data] The data to pass along into the event data.
   */
  _dispatchEvent(e, t = null) {
    const i = {
      ...t,
      highlight: this
    };
    this.eventBus.emit(
      e,
      {
        context: this,
        data: i
      }
    );
  }
  /**
   * Get the highlight-data that is used to save state to the DB.
   * @returns {Object} The highlight data to be used in a save-state.
   */
  getData() {
    var s;
    const e = this.metadata || {};
    let t = e.asset_id || null;
    if (!t && e.references) {
      const n = e.references.find((c) => c.reference_type === "asset");
      n && (t = n.reference_id);
    }
    return t || (t = ((s = this._domHelper.getParentElements(this._selection.startNode, ".cit-row")[0]) == null ? void 0 : s.dataset.guid) || null), {
      ...e,
      id: this.id,
      node_1: this._selection.startNodeSelector,
      offset_1: this._selection.startOffset,
      node_2: this._selection.endNodeSelector,
      offset_2: this._selection.endOffset,
      asset_id: t,
      color: `hl_${this.color}`,
      selected_text: this._selectionText,
      references: e.references || []
    };
  }
  /**
   * The API saves data in snake-case but returns it in camel-case.
   * This is our attempt to normalize some of the data on the FE when manipulating it.
   * @returns {Object} Camel-case data.
   */
  getDataCamelCase() {
    const e = this.getData(), t = {
      ...e,
      node1: e.node_1,
      offset1: e.offset_1,
      node2: e.node_2,
      offset2: e.offset_2,
      assetId: e.asset_id,
      courseGuid: e.course_id,
      guidConceptId: e.concept_id,
      relationshipTypeGuid: e.relationship_type_id,
      subdisciplineGuid: e.subdiscipline_id,
      unitGuid: e.unit_id
    };
    return [
      "node_1",
      "offset_1",
      "node_2",
      "offset_2",
      "asset_id",
      "course_id",
      "concept_id",
      "relationship_type_id",
      "subdiscipline_id",
      "unit_id"
    ].forEach((s) => delete t[s]), t;
  }
  /**
   * Grabs all the elements in the DOM corresponding to the current highlight.
   * @returns {NodeList} Returns a NodeList of all the elements in the DOM for the current highlight.
   */
  getHighlightElements() {
    const t = `.de-highlight[data-highlight-client-id="${CSS.escape(this.clientId)}"]`;
    return [
      ...document.querySelectorAll(t)
    ];
  }
  /**
   * Inject the highlight element on the given node with optional start and end offsets.
   * @private
   * @param {Node} node The text node to inject the highlight into.
   * @param {Number} [startOffset] An optional start offset.
   * @param {Number} [endOffset] An optional end offset.
   */
  _injectHighlightElement(e, t = null, i = null) {
    const s = document.createElement("mark");
    t !== null && i !== null && t === i || (s.classList.add(
      ...this.colorCss.css.concat(
        this.colorCss.legacyCss
      )
    ), s.setAttribute(
      "data-highlight-client-id",
      this.clientId
    ), this.id && s.setAttribute(
      "data-highlight-id",
      this.id
    ), s.setAttribute(
      "tabindex",
      "0"
    ), d.injectElementInNode(
      e,
      s,
      t,
      i
    ));
  }
  /**
   * Injects the note data attributes into all highlightElements
   * and svg into last element of highlightElements.
   */
  injectNoteElement(e) {
    this.removeNoteElement();
    const t = this.getHighlightElements(), i = t[t.length - 1], s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    t.forEach((n) => {
      n.setAttribute("data-note-id", e == null ? void 0 : e.id);
    }), s.innerHTML = `<use xlink:href="${r.iconsSvgPath}#highlight-note" />`, s.classList.add("de-note"), s.setAttribute("data-highlight-client-id", this.clientId), i.append(s), i.classList.add("de-highlight--has-note");
  }
  /**
   * Removes the note svg from last element of highlightElements.
   */
  removeNoteElement() {
    const e = this.getHighlightElements(), t = e[e.length - 1], { lastChild: i } = t;
    e.forEach((s) => {
      s.hasAttribute("data-note-id") && s.removeAttribute("data-note-id");
    }), t.classList.remove("de-highlight--has-note"), i.nodeName === "svg" && i.remove();
  }
  /**
   * Refreshes the highlight elements in the DOM.
   */
  refreshHighlight() {
    this.removeHighlight(), this.createHighlight();
  }
  /**
   * Remove the current highlight elements from the DOM.
   */
  removeHighlight() {
    this.getHighlightElements().forEach((t) => {
      const i = t.innerHTML;
      d.replaceNodeWithContent(t, i);
    });
  }
  /**
   * Save the current highlight to the database.
   * @param {String} csrfToken The CSRF token for the request.
   * @returns {Promise} The promise from the appropriate underlying axios calls.
   */
  async save(e) {
    const t = this.getData();
    if (this.id)
      return w(this.id, t);
    !this.id && "id" in t && delete t.id;
    const i = await L(
      t,
      e
    );
    return this.id = i.data.id, this.getHighlightElements().forEach((s) => {
      s.setAttribute(
        "data-highlight-id",
        this.id
      );
    }), i.data;
  }
  /**
   * Selects/makes active a current highlight on the screen. Implicitly dispatches a 'select' event on the instance as well.
   * @emits Highlight#select
   */
  select(e = 0) {
    r._setActiveHighlight(this), this.getHighlightElements().forEach((i) => i.classList.add("de-highlight--selected"));
    const t = this.getHighlightElements()[0];
    if (!d.isNodeVisible(t, e)) {
      const s = t.getBoundingClientRect().top;
      s < 0 ? window.scrollBy({
        top: s - e,
        behavior: "smooth"
      }) : window.scrollTo({
        top: s - e,
        behavior: "smooth"
      });
    }
    this._dispatchEvent("select");
  }
  /**
   * The selector post-processor used to generate the correct data for highlighting save-states.
   * @private
   * @param {Node} node The current element being processed.
   * @param {Object} selectorData
   * @returns {?String} The string selector to use, or `null` to ignore the current element.
   */
  // eslint-disable-next-line class-methods-use-this
  _selectorPostProcessor(e, t) {
    var H, v;
    const i = {
      primary: { ...t.primary },
      intermediate: { ...t.intermediate },
      target: { ...t.target }
    }, s = (H = i == null ? void 0 : i.primary) == null ? void 0 : H.element;
    if (!s)
      return t;
    const n = s == null ? void 0 : s.id;
    n && (i.primary.selector = `#${n}`);
    const c = t.target.element, g = (v = c.localName) == null ? void 0 : v.trim().toLowerCase(), u = d.getNthChildString(c), m = `> ${g}${u}`;
    return i.target.selector = m, i;
  }
  /**
   * Set the current highlight color.
   * @param {String} color The highlight color.
   */
  setColor(e) {
    const t = this.color;
    if (e === t)
      return;
    r.colorMeta.has(e) ? this.color = e : this.color = t || r.color.YELLOW, this.getHighlightElements().forEach((n) => {
      n.classList.remove(`de-highlight--${t}`, `hl_${t}`), n.classList.add(`de-highlight--${e}`, `hl_${e}`);
    });
  }
  /**
   * Toggles the visibility of highlight
   */
  toggleVisibility(e) {
    e ? this.createHighlight() : (this.removeNoteElement(), this.removeHighlight());
  }
  /**
   * Attempts to update the highlight instance using the provided data object.
   * @param {Object} highlightData The highlight data-object.
   * @returns {Boolean} Returns `true` if successful, `false` otherwise.
   */
  updateFromData(e) {
    this.id = e.id || null, this.removeHighlight();
    const t = new C({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });
    if (!t.updateFromData({
      startNodeSelector: e.node1,
      startOffset: e.offset1,
      endNodeSelector: e.node2,
      endOffset: e.offset2
    }))
      return !1;
    t.setStale(), this._selection = t, this._selectionText = e.selectedText || t.text || null, this.metadata = {
      asset_id: e.assetId,
      concept_id: e.guidConceptId,
      course_id: e.courseGuid,
      page_id: e.page_id,
      relationship_type_id: e.relationshipTypeGuid,
      subdiscipline_id: e.subdisciplineGuid,
      unit_id: e.unitGuid
    };
    const s = e.color.replace(/^hl_/, "");
    return this.setColor(s), this.createHighlight(), !0;
  }
  /**
   * This method retrieves a copy of the text-selection
   * object at runtime. This is needed because the original
   * selection object is mutable and changes instantly as the
   * user clicks around the window. We do NOT want our data
   * to change in the middle of processing the highlight.
   * @returns {object} An object with a copy `startNode`, `startOffset`, `endNode`, `endOffset` from the text selection on the page.
  */
  updateSelection(e) {
    const { selection: t } = e, i = new C({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });
    i.nodeSelectors = this.nodeSelectors, i.updateFromData({
      startNodeSelector: t.startNodeSelector,
      startOffset: t.startOffset,
      endNodeSelector: t.endNodeSelector,
      endOffset: t.endOffset
    }), i.setStale(), this._selection = i, this._selectionText = i.text, (this._domHelper.isNodeInIgnoredList(t.startNode) || this._domHelper.isNodeInIgnoredList(t.endNode)) && (this._selection = null);
  }
  /**
   * Get the active highlight selected in the memory/DOM.
   * Read-only property. To set the active highlight, call
   * `.select()` on the appropriate highlight.
   * @readonly
   * @type {Highlight}
   */
  static get activeHighlight() {
    return this._activeHighlight;
  }
  /**
   * The highlight Color enum. This should (relatively closely) match the color
   * string identifiers used in highlighting and the highlight data.
   * @static
   * @constant
   * @type {Object}
   */
  static get color() {
    return h;
  }
  /**
   * A `Map` of the color and various metadata associated with them.
   * @static
   * @constant
   * @type {Map}
   */
  static get colorMeta() {
    return E;
  }
  /**
   * A map of the highlights currently available on the page. The keys are based on `clientId`.
   * @static
   * @readonly
   * @type {Map}
   */
  static get highlights() {
    return this._highlights;
  }
  /**
   * Registers the Highlight instance with the singleton for managing it better.
   * This also helps ensure we only attach event-listeners when there are active
   * instances on the page.
   * @param {Highlight} highlight An instance of the Highlight.
   */
  static add(e) {
    this.highlights.set(
      e.clientId,
      e
    );
  }
  /**
   * Batch deletes a the given set of highlights.
   * WARNING: This operation is non-atomic.
   * TODO: Work with BE to update the API to make these operations atomic.
   * @param {Array} highlights An array of highlight objects to delete from the database.
   * @returns {Promise} A promise to hook into to know when the delete completes (or fails).
   */
  static async batchDelete(e) {
    const t = [];
    return e.forEach((i) => {
      t.push(
        i.delete()
      );
    }), Promise.all(t);
  }
  /**
   * Get a `Highlight` instance from the given client-id.
   * @param {Number} highlightClientId The client-id for the requested highlight.
   * @returns {?Highlight} Returns the matching `Highlight` instance or `null` if not found.
   */
  static getByClientId(e) {
    const t = parseInt(e, 10);
    return this.highlights.get(t) || null;
  }
  /**
   * Get a `Highlight` instance from the database id.
   * @param {String} highlightId The id for the requested highlight.
   * @returns {?Highlight} Returns the matching `Highlight` instance or `null` if not found.
   */
  static getById(e) {
    for (const [t, i] of this.highlights)
      if (i.id === e)
        return i;
    return null;
  }
  /**
   * Returns a unique numeric client-id for the current window and increments the nextClientId counter by 1.
   * @returns {Number} A unique numeric client-id for the current window.
   */
  static getNextClientId() {
    const e = this._nextClientId;
    return this._nextClientId += 1, e;
  }
  /**
   * Retrieve the associated highlight object from a given node in the DOM.
   * @param {Node} node The node front which to retrieve the highlight.
   * @returns {?Highlight} The highlight instance, or `null` if not found.
   */
  static getHighlightFromNode(e) {
    const t = {
      highlight: null,
      highlightElement: null
    };
    if (!e)
      return t;
    const i = d.isElementNode(e) ? e : e.parentElement;
    if (!i.classList.contains("de-highlight"))
      return t;
    const s = parseInt(
      i.getAttribute("data-highlight-client-id"),
      10
    ), n = this.getByClientId(s);
    return n && (t.highlight = n, t.highlightElement = i), t;
  }
  /**
   * Unregisters the Highlight instance with the singleton for managing it better.
   * This helps ensure we clean up any attached event-listeners after the last
   * instance has been removed from use on the page.
   * @param {Number} clientId The client-id of an instance of Highlight.
   */
  static remove(e) {
    this.highlights.get(e) && this.highlights.delete(e);
  }
  /**
   * Remove all highlights from the DOM.
   */
  static removeAll() {
    this.highlights.forEach((e) => {
      e.destroy();
    });
  }
  /**
   * Sets (or unsets) the active highlight being tracked on screen. Passing `null` unsets it.
   * This method is NOT to be called directly. Use the `.select()` and `.deselect()` methods
   * on the highlight instance instead.
   * @private
   * @param {Highlight} highlight The highlight instance.
   */
  static _setActiveHighlight(e) {
    const t = this.activeHighlight;
    e !== t && (t && (this._activeHighlight = null, t.deselect()), e && (this._activeHighlight = e));
  }
};
// +===================================+
// | Static implementation starts here |
// +===================================+
l(r, "_activeHighlight", null), l(r, "_highlights", /* @__PURE__ */ new Map()), l(r, "_nextClientId", 1), /**
 * Contains the path to the svg to be used to display icons.
 * @type {String}
 */
l(r, "iconsSvgPath", `${(I = window.paths) == null ? void 0 : I.core_static}
        /node_modules/@discoveryedu/nebula-icons/nebula.svg`);
let N = r;
export {
  N as H,
  M as a,
  j as g,
  F as r,
  k as s
};
